// @ts-nocheck
/**
 * SIMA関連エクスポート/インポート関数
 * downLoad.jsから分離
 */
import store from '@/store'
import proj4 from 'proj4'
import maplibregl from 'maplibre-gl'
import JSZip from 'jszip'
import * as turf from '@turf/turf'
import { zahyokei } from './downLoad'
import { simaLoadForUser } from './downLoad'

export function simaToGeoJSON(simaData, map, simaZahyokei, isFlyto, isGeojson) {
  if (!simaData) return
  const lines = simaData.split('\n')
  let coordinates = {} // 座標データを格納
  let coordinatesUsedInPolygons = new Set() // 区画データで使用された座標IDを追跡
  let features = [] // GeoJSONのフィーチャーを格納
  let currentFeature = null
  let firstCoordinateChecked = false
  let detectedCRS
  let code
  let hasPolygonData = false // 区画データの有無を判定

  const kei = simaZahyokei || store.state.zahyokei
  const found = zahyokei.find((item) => item.kei === kei)
  if (!found) {
    console.error(`[simaToGeoJSON] 座標系が見つかりません: "${kei}"`)
    return
  }
  code = found.code
  // alert(code)

  lines.forEach((line) => {
    const parts = line.split(',')
    const type = parts[0].trim()

    // 座標データ (A01)
    if (type === 'A01') {
      const id = parts[1].trim()
      const x = parseFloat(parts[3]) // X座標 (東方向)
      const y = parseFloat(parts[4]) // Y座標 (北方向)
      const h = parseFloat(parts[5]) || 0 // 標高

      // 最初の座標で座標系を判定
      if (!firstCoordinateChecked) {
        detectedCRS = determinePlaneRectangularZone(x, y)
        firstCoordinateChecked = true
      }

      try {
        // 座標系をEPSG:4326に変換 (x, yの順番で指定)
        const [lon, lat] = proj4(code, 'EPSG:4326', [y, x])
        coordinates[id] = { coords: [lon, lat], h, simaX: x, simaY: y }
      } catch (error) {
        console.error(`座標変換エラー: ${error.message}`)
        coordinates[id] = { coords: [x, y], h, simaX: x, simaY: y } // 変換失敗時は元の座標を使用
      }
    }

    // 区画データ (D00, B01, D99)
    if (type === 'D00') {
      hasPolygonData = true // 区画データが存在
      currentFeature = {
        type: 'Feature',
        properties: {
          id: parts[1].trim(),
          chiban: parts[2]?.trim() || null,
          vertices: [], // 頂点データ [{id, simaX, simaY}]
        },
        geometry: {
          type: 'Polygon',
          coordinates: [[]],
        },
      }
    } else if (type === 'B01' && currentFeature) {
      const coordId = parts[1].trim()
      if (coordinates[coordId]) {
        currentFeature.geometry.coordinates[0].push(coordinates[coordId].coords)
        currentFeature.properties.vertices.push({
          id: coordId,
          simaX: coordinates[coordId].simaX,
          simaY: coordinates[coordId].simaY,
        })
        coordinatesUsedInPolygons.add(coordId) // この座標が区画データで使用されたことを記録
      }
    } else if (type === 'D99' && currentFeature) {
      // ポリゴンを閉じる（最初の座標を最後に追加）
      if (currentFeature.geometry.coordinates[0].length > 0) {
        const firstCoord = currentFeature.geometry.coordinates[0][0]
        currentFeature.geometry.coordinates[0].push(firstCoord)
      }
      // フィーチャー終了
      features.push(currentFeature)
      currentFeature = null
    }
  })

  // 区画データに含まれていない座標をポイントとして追加
  Object.keys(coordinates).forEach((id) => {
    const chiban = lines
      .find((line) => new RegExp(`A01\\s*,\\s*${id}\\s*,`).test(line))
      ?.split(',')[2]
      ?.trim()
    if (!coordinatesUsedInPolygons.has(id)) {
      features.push({
        type: 'Feature',
        properties: {
          id: id,
          chiban: chiban,
          type: 'point',
          h: coordinates[id].h,
          simaX: coordinates[id].simaX,
          simaY: coordinates[id].simaY,
        },
        geometry: {
          type: 'Point',
          coordinates: coordinates[id].coords,
        },
      })
    }
  })

  // if (isGeojson) {
  // 区画データの頂点をポイントとして追加
  Object.keys(coordinates).forEach((id) => {
    const chiban = lines
      .find((line) => new RegExp(`A01\\s*,\\s*${id}\\s*,`).test(line))
      ?.split(',')[2]
      ?.trim()
    if (coordinatesUsedInPolygons.has(id)) {
      features.push({
        type: 'Feature',
        properties: {
          id: id,
          chiban: chiban,
          type: 'vertex',
          h: coordinates[id].h,
          simaX: coordinates[id].simaX,
          simaY: coordinates[id].simaY,
        },
        geometry: {
          type: 'Point',
          coordinates: coordinates[id].coords,
        },
      })
    }
  })
  // }

  // GeoJSONオブジェクトを生成
  const geoJSON = {
    type: 'FeatureCollection',
    features: features,
  }

  if (isGeojson) {
    return geoJSON
  }


  if (map) {
    if (map.getSource('sima-data')) {
      map.getSource('sima-data').setData(geoJSON)
    } else {
      map.addSource('sima-data', {
        type: 'geojson',
        data: geoJSON,
      })
    }
    if (!map.getLayer('sima-layer')) {
      map.addLayer({
        id: 'sima-layer',
        type: 'fill',
        source: 'sima-data',
        filter: ['==', '$type', 'Polygon'],
        paint: {
          'fill-color': '#088',
          'fill-opacity': 0.7,
        },
      })
      map.addLayer({
        id: 'sima-borders',
        type: 'line',
        source: 'sima-data',
        layout: {},
        paint: {
          'line-color': '#000',
          'line-width': 2,
        },
      })

      // ポイント用ラベルレイヤー
      map.addLayer({
        id: 'sima-label-point',
        type: 'symbol',
        source: 'sima-data',
        layout: {
          'text-field': ['get', 'chiban'],
          'text-offset': [0, 1.3], // ラベルを下にずらす
        },
        paint: {
          'text-color': 'rgba(0, 0, 0, 1)',
          'text-halo-color': 'rgba(255,255,255,0.7)',
          'text-halo-width': 1.0,
        },
        minzoom: 14,
        filter: ['==', '$type', 'Point'],
      })
      map.addLayer({
        id: 'sima-points',
        type: 'circle',
        source: 'sima-data',
        layout: {},
        paint: {
          'circle-radius': 5,
          'circle-color': ['case', ['!=', ['get', 'h'], 0], '#1565C0', 'navy'],
          'circle-stroke-width': 1,
          'circle-stroke-color': '#000',
        },
        filter: ['==', ['get', 'type'], 'point'],
      })
      map.addLayer({
        id: 'sima-Vertex',
        type: 'circle',
        source: 'sima-data',
        layout: {},
        paint: {
          'circle-radius': ['interpolate', ['linear'], ['zoom'], 15, 0, 18, 4],
          'circle-color': ['case', ['!=', ['get', 'h'], 0], '#1565C0', '#f00'],
        },
        filter: ['==', ['get', 'type'], 'vertex'],
      })
      map.addLayer({
        id: 'sima-label',
        type: 'symbol',
        source: 'sima-data',
        layout: {
          'text-field': ['get', 'chiban'],
        },
        paint: {
          'text-color': 'rgba(0, 0, 0, 1)',
          'text-halo-color': 'rgba(255,255,255,0.7)',
          'text-halo-width': 1.0,
        },
        minzoom: 17,
        filter: ['==', '$type', 'Polygon'],
      })
      // 標高ラベル（H!=0のポイントのみ）
      map.addLayer({
        id: 'sima-label-h',
        type: 'symbol',
        source: 'sima-data',
        layout: {
          'text-field': ['concat', 'H:', ['to-string', ['get', 'h']]],
          'text-offset': [0, -1.3],
          'text-size': 11,
        },
        paint: {
          'text-color': '#1565C0',
          'text-halo-color': 'rgba(255,255,255,0.9)',
          'text-halo-width': 1.5,
        },
        minzoom: 15,
        filter: ['all', ['==', '$type', 'Point'], ['!=', 'h', 0]],
      })
      setTimeout(() => {
        map.addLayer({
          id: 'sima-polygon-points',
          type: 'circle',
          source: 'sima-data',
          layout: {},
          paint: {
            'circle-radius': ['interpolate', ['linear'], ['zoom'], 15, 0, 18, 4],
            'circle-color': '#f00',
          },
          filter: ['==', '$type', 'Polygon'],
        })
      }, 1000)
    }
  }

  if (isFlyto) {
    // GeoJSONの範囲にフライ (地図を移動)
    const bounds = new maplibregl.LngLatBounds()
    geoJSON.features.forEach((feature) => {
      if (feature.geometry.type === 'Point') {
        bounds.extend(feature.geometry.coordinates)
      } else if (feature.geometry.type === 'Polygon') {
        feature.geometry.coordinates[0].forEach((coord) => {
          bounds.extend(coord)
        })
      }
    })
    if (geoJSON.features.length === 1 && geoJSON.features[0].geometry.type === 'Point') {
      map.fitBounds(bounds, { padding: 20, maxZoom: 18 })
    } else {
      map.fitBounds(bounds, { padding: 20 })
    }
  }

  // ファイル入力をリセット
  const uploadInput = document.querySelector('#simaFileInput')
  if (uploadInput) {
    uploadInput.value = ''
  }
  return JSON.stringify(geoJSON, null, 2)
}

export function simaFileUpload(event) {
  store.commit('setTiffAndWorldFile', event.target.files)
  const file = event.target.files[0]
  if (!file) return
  if (!file.name.endsWith('.sim')) {
    alert('SIMAファイル(.sim)をアップロードしてください。')
    return
  }
  const reader = new FileReader()
  reader.onload = (e) => {
    const arrayBuffer = e.target.result // ArrayBufferとして読み込む
    const text = new TextDecoder('shift-jis').decode(arrayBuffer) // Shift JISをUTF-8に変換
    const simaData = text
    if (store.state.userId) {
      const map1 = store.state.map01
      simaLoadForUser(map1, true, simaData, store.state.zahyokei)
    } else {
      ddSimaUpload(simaData)
    }
  }
  reader.readAsArrayBuffer(file)
}

export function ddSimaUpload(simaData) {
  store.state.simaZahyokei.map01 = store.state.zahyokei
  store.state.simaData.map01 = simaData
  store.commit('setSimaText', JSON.stringify({
    text: simaData,
    zahyokei: store.state.zahyokei,
    opacity: 0.7,
  }))
  // alert('読み込み' + store.state.simaText)
  try {
    const map = store.state.map01
    simaToGeoJSON(simaData, map, null, true)
    store.commit('setSnackbarValue', true)
  } catch (error) {
    console.error(`変換エラー: ${error.message}`)
  }
}

function determinePlaneRectangularZone(x, y) {
  let closestZone = null
  let minDistance = Number.MAX_VALUE

  for (let i = 0; i < 19; i++) {
    try {
      const [lon, lat] = proj4(`EPSG:666${8 + i}`, 'EPSG:4326', [x, y])
      const [zoneLon, zoneLat] = proj4(`EPSG:666${8 + i}`, 'EPSG:4326', [0, 0])
      const distance = Math.sqrt(Math.pow(lon - zoneLon, 2) + Math.pow(lat - zoneLat, 2))

      if (distance < minDistance) {
        minDistance = distance
        closestZone = i + 1
      }
    } catch (error) {
      // console.warn(`系 ${i + 1} の変換でエラー:`, error);
    }
  }
  return closestZone
}

export function savePointSimaForSaga(map) {
  const code = 'EPSG:2444'

  const features = map.queryRenderedFeatures({
    layers: ['oh-saga-kijyunten-point'], // 対象のレイヤー名を指定
  })
  // GeoJSON形式に変換
  const geojson = {
    type: 'FeatureCollection',
    features: features.map((feature) => ({
      type: 'Feature',
      geometry: feature.geometry,
      properties: feature.properties,
    })),
  }

  let simaData = 'G00,01,open-hinata3,\n'
  simaData += 'Z00,座標ﾃﾞｰﾀ,,\n'
  simaData += 'A00,\n'

  let A01Text = ''
  let j = 1

  // 座標を関連付けるマップ
  const coordinateMap = new Map()

  geojson.features.forEach((feature) => {
    if (feature.geometry.type !== 'Point') {
      console.warn('Unsupported geometry type:', feature.geometry.type)
      return // Point以外はスキップ
    }

    const coord = feature.geometry.coordinates
    if (Array.isArray(coord) && Number.isFinite(coord[0]) && Number.isFinite(coord[1])) {
      // const [x, y] = proj4('EPSG:4326', code, [coord[0],coord[1]]); // 座標系変換
      const [x, y] = [feature.properties.Y, feature.properties.X]
      const coordinateKey = `${x},${y}`
      const name = feature.properties.点名
      const zahyoY = y
      const zahyoX = x
      const zahyoZ = feature.properties.標高
      if (!coordinateMap.has(coordinateKey)) {
        coordinateMap.set(coordinateKey, j)
        A01Text += 'A01,' + j + ',' + name + ',' + zahyoY + ',' + zahyoX + ',' + zahyoZ + ',\n'
        // A01Text += 'A01,' + j + ',' + j + ',' + zahyoY + ',' + zahyoX + ',\n';
        j++
      }
    } else {
      console.error('Invalid coordinate skipped:', coord)
    }
  })

  simaData += A01Text + 'A99,\n'
  simaData += 'A99,END,,\n'

  // UTF-8で文字列をコードポイントに変換
  const utf8Array = window.Encoding.stringToCode(simaData)
  // UTF-8からShift-JISに変換
  const shiftJISArray = window.Encoding.convert(utf8Array, 'SJIS')
  // Shift-JISエンコードされたデータをUint8Arrayに格納
  const uint8Array = new Uint8Array(shiftJISArray)
  // Blobを作成（MIMEタイプを変更）
  const blob = new Blob([uint8Array], { type: 'application/octet-stream' })
  // ダウンロード用リンクを作成
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  const fileName = 'saga.sim'
  link.download = fileName // ファイル名を正確に指定
  // リンクをクリックしてダウンロード
  link.click()
  URL.revokeObjectURL(link.href)
}

export function savePointSima(map, geojson, zahyokei0) {
  const found = zahyokei.find((item) => item.kei === zahyokei0)
  if (!found) {
    console.error(`[savePointSima] 座標系が見つかりません: "${zahyokei0}"`)
    alert(`座標系「${zahyokei0 || '(未設定)'}」が見つかりません。`)
    return
  }
  const code = found.code

  let simaData = 'G00,01,open-hinata3,\n'
  simaData += 'Z00,座標ﾃﾞｰﾀ,,\n'
  simaData += 'A00,\n'

  let A01Text = ''
  let j = 1

  // 座標を関連付けるマップ
  const coordinateMap = new Map()

  geojson.features.forEach((feature) => {
    if (feature.geometry.type !== 'Point') {
      console.warn('Unsupported geometry type:', feature.geometry.type)
      return // Point以外はスキップ
    }

    const coord = feature.geometry.coordinates
    if (Array.isArray(coord) && Number.isFinite(coord[0]) && Number.isFinite(coord[1])) {
      const [x, y] = proj4('EPSG:4326', code, [coord[0], coord[1]]) // 座標系変換
      const coordinateKey = `${x},${y}`
      const name = ''
      const zahyoY = y
      const zahyoX = x
      const zahyoZ = coord[2]
      if (!coordinateMap.has(coordinateKey)) {
        coordinateMap.set(coordinateKey, j)
        A01Text += 'A01,' + j + ',' + j + ',' + zahyoY + ',' + zahyoX + ',' + zahyoZ + ',\n'
        // A01Text += 'A01,' + j + ',' + j + ',' + zahyoY + ',' + zahyoX + ',\n';
        j++
      }
    } else {
      console.error('Invalid coordinate skipped:', coord)
    }
  })

  simaData += A01Text + 'A99,\n'
  simaData += 'A99,END,,\n'

  // UTF-8で文字列をコードポイントに変換
  const utf8Array = window.Encoding.stringToCode(simaData)
  // UTF-8からShift-JISに変換
  const shiftJISArray = window.Encoding.convert(utf8Array, 'SJIS')
  // Shift-JISエンコードされたデータをUint8Arrayに格納
  const uint8Array = new Uint8Array(shiftJISArray)
  // Blobを作成（MIMEタイプを変更）
  const blob = new Blob([uint8Array], { type: 'application/octet-stream' })
  // ダウンロード用リンクを作成
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  const fileName = 'point.sim'
  link.download = fileName // ファイル名を正確に指定
  // リンクをクリックしてダウンロード
  link.click()
  URL.revokeObjectURL(link.href)
}

export function saveSimaImage(chiban, data, zahyokei) {
  let stageResult = null
  const safeBaseName = (() => {
    const raw = (typeof chiban === 'string' ? chiban : '') || ''
    const trimmed = raw.trim()
    if (!trimmed.length) return 'kyuseki'
    return trimmed.replace(/[\\/:*?"<>|]/g, '_')
  })()
  const simaFileName = `${safeBaseName}_求積表.sim`

  const prepareUploadArtifacts = () => {
    try {
      let bytes
      let decodeLabel
      if (
        window.Encoding &&
        typeof window.Encoding.stringToCode === 'function' &&
        typeof window.Encoding.convert === 'function'
      ) {
        const codes = window.Encoding.stringToCode(simaData)
        bytes = new Uint8Array(window.Encoding.convert(codes, 'SJIS'))
        decodeLabel = 'shift_jis'
      } else {
        if (typeof TextEncoder !== 'undefined') {
          bytes = new TextEncoder().encode(simaData)
        } else {
          const codes = Array.from(simaData, (ch) => ch.charCodeAt(0))
          bytes = new Uint8Array(codes)
        }
        decodeLabel = 'utf-8'
      }

      const simFile = new File([bytes], simaFileName, { type: 'text/plain' })
      const buffer = bytes.buffer.slice(0)
      let decodedText = simaData
      if (decodeLabel === 'shift_jis' && typeof TextDecoder !== 'undefined') {
        try {
          decodedText = new TextDecoder('shift_jis').decode(buffer)
        } catch (e) {
          decodedText = simaData
        }
      }

      stageResult = { file: simFile, text: decodedText }
    } catch (err) {
      console.warn('Failed to prepare SIM artifacts for upload', err)
      stageResult = null
    }
  }

  // 配列からGeoJSONを作成する関数
  function createGeoJSON(dataArray) {
    const features = dataArray.map(([name, lon, lat]) => {
      return turf.point([lon, lat], { name })
    })
    return turf.featureCollection(features)
  }
  // GeoJSONを作成
  const geojson = createGeoJSON(data)

  let simaData = 'G00,01,open-hinata3,\n'
  simaData += 'Z00,座標ﾃﾞｰﾀ,,\n'
  simaData += 'A00,\n'

  let A01Text = ''
  let B01Text = ''
  let i = 1

  // 座標を関連付けるマップ
  const coordinateMap = new Map()

  geojson.features.forEach((feature) => {
    const coord = feature.geometry.coordinates
    const [x, y] = coord
    const z = 0
    const coordinateKey = `${x},${y}`
    const name = feature.properties.name
    if (!coordinateMap.has(coordinateKey)) {
      coordinateMap.set(coordinateKey, i)
      A01Text += 'A01,' + i + ',' + name + ',' + x + ',' + y + ',' + z + ',\n'
      B01Text += 'B01,' + i + ',' + name + ',\n'
      i++
    }
  })
  // simaData += A01Text + 'A99\n';
  simaData += A01Text + 'A99,\nZ00,区画データ,\nD00,1,' + chiban + ',1,\n' + B01Text + 'D99,\n'
  simaData += 'A99,END'

  store.commit('setSimaText', JSON.stringify({
    text: simaData,
    zahyokei: zahyokei,
    opacity: 0.7,
  }))
  prepareUploadArtifacts()
  if (stageResult && stageResult.file) {
    store.commit('setTiffAndWorldFile', [stageResult.file])
    try {
      store.commit('setSimaTextForUser', JSON.stringify({
        text: stageResult.text,
        zahyokei,
        opacity: 0.7,
      }))
    } catch (e) {
      store.commit('setSimaTextForUser', stageResult.text)
    }
  }
  simaToGeoJSON(simaData, store.state.map01, zahyokei, true)
  store.commit('setSnackbarValue', true)
  return stageResult
}

export async function zipDownloadSimaText(simaTexts) {
  const zip = new JSZip()
  // UTF-8で文字列をコードポイントに変換
  let blob
  simaTexts.forEach((simaText) => {
    const utf8Array = window.Encoding.stringToCode(simaText.simaText)
    // UTF-8からShift-JISに変換
    const shiftJISArray = window.Encoding.convert(utf8Array, 'SJIS')
    // Shift-JISエンコードされたデータをUint8Arrayに格納
    const uint8Array = new Uint8Array(shiftJISArray)
    blob = new Blob([uint8Array], { type: 'application/octet-stream' }) // MIMEタイプを変更
    zip.file(simaText.name + '.sim', blob)
  })

  if (simaTexts.length > 1) {
    // ZIPファイルを生成してダウンロード
    const zipBlob = await zip.generateAsync({ type: 'blob' })
    const zipLink = document.createElement('a')
    zipLink.href = URL.createObjectURL(zipBlob)
    zipLink.download = 'simzip.zip'
    zipLink.click()
    URL.revokeObjectURL(zipLink.href)
  } else {
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = simaTexts[0].name + '.sim'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(link.href)
  }
}

export function downloadSimaText(isUser, fileName0) {
  let simaText
  let fileName = 'sima.sim'
  if (isUser) {
    try {
      simaText = JSON.parse(store.state.simaTextForUser).text
    } catch (e) {
      simaText = store.state.simaTextForUser
      fileName = fileName0 + '部分DL.sim'
    }
  } else {
    simaText = JSON.parse(store.state.simaText).text
  }
  // UTF-8で文字列をコードポイントに変換
  const utf8Array = window.Encoding.stringToCode(simaText)
  // UTF-8からShift-JISに変換
  const shiftJISArray = window.Encoding.convert(utf8Array, 'SJIS')
  // Shift-JISエンコードされたデータをUint8Arrayに格納
  const uint8Array = new Uint8Array(shiftJISArray)
  const blob = new Blob([uint8Array], { type: 'application/octet-stream' }) // MIMEタイプを変更
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(link.href)
}

export function extractSimaById(simaText, targetIds) {
  if (!Array.isArray(targetIds)) targetIds = [targetIds].map(String)
  else targetIds = targetIds.map(String)

  const lines = simaText.split(/\r?\n/)

  // 1. 全B01の点IDセット
  const b01PointSet = new Set()
  // D00ブロック内容保持
  const blockMap = {}
  let inBlock = false,
    curBlock = [],
    curId = null
  for (const line of lines) {
    if (line.startsWith('B01,')) {
      b01PointSet.add(line.split(',')[1])
    }
    if (line.startsWith('D00,')) {
      inBlock = true
      curBlock = [line]
      curId = line.split(',')[1]
    } else if (line.startsWith('D99')) {
      if (inBlock && curId) {
        curBlock.push(line)
        blockMap[curId] = [...curBlock]
      }
      inBlock = false
      curBlock = []
      curId = null
    } else if (inBlock) {
      curBlock.push(line)
    }
  }

  // 2. ポリゴンで参照されてる点ID（B01が属するD00がtargetIdのもののみ）
  const usedA01Ids = new Set()
  for (const id of targetIds) {
    const block = blockMap[id]
    if (block) {
      for (const l of block) {
        if (l.startsWith('B01,')) usedA01Ids.add(l.split(',')[1])
      }
    }
  }

  // 3. ポイントA01: B01に1度も出ず、A01だけでtargetIdに該当するもの
  //    例：A01,16,... で16がB01に出てこないもの
  const pointIdSet = new Set(targetIds.filter((id) => !b01PointSet.has(id)))

  // 4. 出力判定
  let inTargetBlock = false
  let targetBlockId = null
  const output = []
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i]

    // G00, Z00, A00, A99,END,, はそのまま残す
    if (
      line.startsWith('G00,') ||
      line.startsWith('Z00,') ||
      line.startsWith('A00') ||
      line === 'A99' ||
      line === 'A99,END,,'
    ) {
      output.push(line)
      continue
    }

    // A01は「ポイントとして抽出すべきもの」または「usedA01Idsに含まれるもの」だけ残す
    if (line.startsWith('A01,')) {
      const ptId = line.split(',')[1]
      if (pointIdSet.has(ptId) || usedA01Ids.has(ptId)) {
        output.push(line)
      }
      continue
    }

    // D00（targetIdsのみ残す）→以降D99まで残す
    if (line.startsWith('D00,')) {
      const id = line.split(',')[1]
      if (targetIds.includes(id)) {
        inTargetBlock = true
        targetBlockId = id
        output.push(line)
      } else {
        inTargetBlock = false
        targetBlockId = null
      }
      continue
    }
    // D99（今inTargetBlock中なら残す）
    if (line.startsWith('D99')) {
      if (inTargetBlock) output.push(line)
      inTargetBlock = false
      targetBlockId = null
      continue
    }
    // D00～D99間（targetBlockのみ出力）
    if (inTargetBlock) {
      output.push(line)
      continue
    }
    // それ以外（B01など）は全消去
  }

  return output.join('\n')
}

// geoJSONToSIMA
export function geoJSONToSIMA(geojson) {
  let simaData = 'G00,01,open-hinata3,\n'
  simaData += 'Z00,座標ﾃﾞｰﾀ,,\n'
  simaData += 'A00,\n'

  let A01Text = ''
  let B01Text = ''
  let i = 1
  let j = 1
  const coordinateMap = new Map()

  // 統一座標系を決定: XMLインポートの座標系があれば全地物でそれを使用
  let unifiedEpsgCode = null
  for (const feature of geojson.features) {
    const props = feature.properties || {}
    if (props._coordSystem) {
      const match = props._coordSystem.match(/(\d+)/)
      if (match) {
        const zoneNumber = parseInt(match[1], 10)
        if (zoneNumber >= 1 && zoneNumber <= 19) {
          unifiedEpsgCode = `EPSG:${2442 + zoneNumber}`
          break // 最初に見つかった座標系を使用
        }
      }
    }
  }

  // 統一座標系が見つからない場合はstore.state.zahyokeiを使用
  if (!unifiedEpsgCode) {
    const selectedZahyokei = store.state.zahyokei
    if (selectedZahyokei && selectedZahyokei !== 'WGS84') {
      const found = zahyokei.find(item => item.kei === selectedZahyokei)
      if (found) {
        unifiedEpsgCode = found.code
      }
    }
  }

  geojson.features.forEach((feature) => {
    const geomType = feature.geometry?.type
    const props = feature.properties || {}

    // -------- Point / MultiPoint --------
    if (geomType === 'Point' || geomType === 'MultiPoint') {
      const points = geomType === 'Point' ? [feature.geometry.coordinates] : feature.geometry.coordinates

      // Pointの元座標があるかチェック（XMLインポートの基準点など）
      const hasOriginalCoord = props._originalCoords && typeof props._originalCoords === 'object' && !Array.isArray(props._originalCoords)
      const isPublicCoord = props._coordSystem && props._coordSystem.includes('公共')
      const hasBeenModified = props._hasBeenModified === true

      points.forEach((coord, idx) => {
        let simaX, simaY, z

        // 元座標を使う条件: 公共座標 AND 未修正 AND 元座標あり
        if (isPublicCoord && !hasBeenModified && hasOriginalCoord) {
          // 元座標を使用（Pointは単一の{x, y}オブジェクト）
          simaX = props._originalCoords.x
          simaY = props._originalCoords.y
          z = coord[2]
        } else if (unifiedEpsgCode) {
          // WGS84から公共座標に変換
          const [lng, lat, zVal] = coord
          if (!Number.isFinite(lng) || !Number.isFinite(lat)) return
          try {
            const [y, x] = proj4('EPSG:4326', unifiedEpsgCode, [lng, lat])
            simaX = x
            simaY = y
            z = zVal
          } catch (e) {
            console.warn('座標変換エラー (Point):', e)
            return
          }
        } else {
          // 座標系不明の場合はそのまま
          const [lng, lat, zVal] = coord
          simaX = lat
          simaY = lng
          z = zVal
        }

        if (!Number.isFinite(simaX) || !Number.isFinite(simaY)) return

        // 4桁目を切り捨てて3桁にする（四捨五入しない）
        const truncTo3 = (v: number) => (Math.trunc(v * 1000) / 1000).toFixed(3)
        const key = `${truncTo3(simaX)},${truncTo3(simaY)},${z ?? ''}`
        if (!coordinateMap.has(key)) {
          coordinateMap.set(key, j)
          const name = props.名称 || props.地番 || props.chiban || `点${j}`
          A01Text += `A01,${j},${name},${truncTo3(simaX)},${truncTo3(simaY)},${Number.isFinite(z) ? truncTo3(z) : ''},\n`
          j++
        }
      })
      return
    }

    // -------- Polygon / MultiPolygon --------
    const chiban = props.地番 || props.chiban || `地番${i}`
    B01Text += `D00,${i},${chiban},1,\n`

    // 元座標を使用するかどうかの判定
    // ①公共座標かつユーザーが移動拡大縮尺していないときは元座標を使う
    // ②公共座標でも移動等していたらgeojson座標を変換して使う
    // ③任意座標のときはgeojson座標を変換して使う
    const isPublicCoord = props._coordSystem && props._coordSystem.includes('公共')
    const hasBeenModified = props._hasBeenModified === true
    const hasOriginalCoords = props._originalCoords && Array.isArray(props._originalCoords)

    // 元座標を使う条件: 公共座標 AND 未修正 AND 元座標あり
    const useOriginalCoords = isPublicCoord && !hasBeenModified && hasOriginalCoords

    let coordinates = []
    let useOriginal = false // 元座標を使っているかどうかのフラグ

    if (useOriginalCoords) {
      // 元座標を使用（X, Y の順）
      const origRing = props._originalCoords.map(c => [c.x, c.y])
      // 閉じていなければ閉じる
      if (origRing.length > 1) {
        const first = origRing[0]
        const last = origRing[origRing.length - 1]
        if (first[0] !== last[0] || first[1] !== last[1]) {
          origRing.push([first[0], first[1]])
        }
      }
      coordinates = [origRing]
      useOriginal = true
    } else if (geomType === 'Polygon') {
      coordinates = feature.geometry.coordinates.map((ring) => {
        if (ring.length > 1 && (ring[0][0] !== ring[ring.length - 1][0] || ring[0][1] !== ring[ring.length - 1][1])) {
          ring.push(ring[0])
        }
        return ring
      })
    } else if (geomType === 'MultiPolygon') {
      coordinates = feature.geometry.coordinates.flat().map((ring) => {
        if (ring.length > 1 && (ring[0][0] !== ring[ring.length - 1][0] || ring[0][1] !== ring[ring.length - 1][1])) {
          ring.push(ring[0])
        }
        return ring
      })
    } else {
      console.warn('Unsupported geometry:', geomType)
      return
    }

    // 座標系コードを決定（geojson座標を変換する場合に使用）
    // 統一座標系が決定されていればそれを使用（XMLインポートとユーザー描画の混在に対応）
    let epsgCode = null
    if (!useOriginal) {
      epsgCode = unifiedEpsgCode
    }

    coordinates.forEach((ring, ringIndex) => {
      const len = ring.length
      let prevPointNum = null // 前の座標番号（連続重複削除用）
      ring.forEach((coord, index) => {
        let simaX, simaY, z

        if (useOriginal) {
          // 元座標を使用: [x, y] 順（X=北, Y=東）
          const [x, y, zVal] = coord
          simaX = x // X座標（北方向）
          simaY = y // Y座標（東方向）
          z = zVal
        } else if (epsgCode) {
          // geojson座標を平面直角座標に変換: [lng, lat] → [y, x]
          const [lng, lat, zVal] = coord
          if (!Number.isFinite(lng) || !Number.isFinite(lat)) return
          try {
            const [y, x] = proj4('EPSG:4326', epsgCode, [lng, lat])
            simaX = x // X座標（北方向）
            simaY = y // Y座標（東方向）
            z = zVal
          } catch (e) {
            console.warn('座標変換エラー:', e)
            return
          }
        } else {
          // 座標系不明の場合はそのまま（WGS84の度数）
          const [lng, lat, zVal] = coord
          simaX = lat
          simaY = lng
          z = zVal
        }

        if (!Number.isFinite(simaX) || !Number.isFinite(simaY)) return

        // 4桁目を切り捨てて3桁にする（四捨五入しない）
        const truncTo3 = (v: number) => (Math.trunc(v * 1000) / 1000).toFixed(3)
        const key = `${truncTo3(simaX)},${truncTo3(simaY)},${z ?? ''}`
        if (!coordinateMap.has(key)) {
          coordinateMap.set(key, j)
          // SIMAフォーマット: A01,番号,名称,X座標,Y座標,標高
          A01Text += `A01,${j},${j},${truncTo3(simaX)},${truncTo3(simaY)},${Number.isFinite(z) ? truncTo3(z) : ''},\n`
          j++
        }
        const current = coordinateMap.get(key)

        // 連続する重複頂点を削除（前の座標と同じ番号ならスキップ）
        if (current === prevPointNum) return
        prevPointNum = current

        const isLast = index === len - 1 && ringIndex === coordinates.length - 1
        B01Text += `B01,${current},${current},\n`
        if (isLast) B01Text += `D99,\n`
      })
    })

    i++
  })

  simaData += A01Text + 'A99,\n' + B01Text
  return simaData
}
